import React from 'react';

import { FeedItemActivityType, IFeedItem } from 'api/feed/types';

import { RichContentActivity } from './RichContentActivity';
import { CoverImageChanged } from './CoverImageChanged';
import { DescriptionChanged } from './DescriptionChanged';

interface IProps {
  item: IFeedItem;
}

export function ActivityContent(props: IProps) {
  const { item } = props;

  const { activity } = item;

  if (!activity) {
    return null;
  }

  switch (activity.activityType) {
    case FeedItemActivityType.ABOUT_GROUP_CHANGED:
      return <DescriptionChanged item={item} />;

    case FeedItemActivityType.GROUP_COVER_CHANGED:
      return <CoverImageChanged item={item} />;

    case FeedItemActivityType.DRAFT_JS:
    case FeedItemActivityType.RICH_CONTENT:
      return <RichContentActivity item={item} />;

    default:
      return null;
  }
}

ActivityContent.displayName = 'ActivityContent';
